import React, { useEffect } from 'react'
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { CustomEase } from 'gsap/all';
import './style.scss';

export default function PredictGraphDown({ isStart }) {
    gsap.registerPlugin(MotionPathPlugin);
    gsap.registerPlugin(CustomEase);
    useEffect(() => {
        if (isStart) {
            gsap.set("#path", {
                strokeDasharray: "1000",
                strokeDashoffset: "1000",
                stroke: "#5BF0A5"
            });

            gsap.to("#gradient-container", {
                duration: 3,
                width: "100%",
                ease: CustomEase.create("custom", "M0,0 C0.208,0.147 0.472,0.455 0.496,0.496 0.574,0.63 0.774,0.715 1,1 "),


            });


            gsap.to("#path", {
                duration: 3,
                strokeDashoffset: 650,
                ease: CustomEase.create("custom", "M0,0 C0.208,0.147 0.472,0.455 0.496,0.496 0.574,0.63 0.774,0.715 1,1 "),

            });


            gsap.fromTo(
                "#circle",
                {
                    opacity: 0,
                    scale: 0,
                    transformOrigin: "50% 50%",
                },
                {
                    opacity: 1,
                    scale: 1,
                    delay: 3,
                    duration: .5,
                    ease: "power1.inOut"
                }
            );
        }
    }, [isStart]);
    return (
        <div className="predict-item__img">
            <div className="predict-item__img--gradient">
                <div id="gradient-container">
                    <svg width="335" height="204" viewBox="0 0 335 204" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <g clip-path="url(#clip1_10_30035)">
                            <path d="M307 184C285.568 181.334 249.847 189.359 222.181 132.154C187.598 60.6465 161.355 63.6813 103.989 67.6728C62.2956 70.5738 37.3181 43.0683 26 24" stroke="#CAD4DD" stroke-width="3.14635" />
                            <path d="M220.709 132.225C246.899 189.468 286.712 181.437 307 184.105V193H26.5V24C37.214 43.0808 69.3583 70.6044 108.826 67.7015C163.129 63.7074 187.972 60.6707 220.709 132.225Z" fill="url(#paint5_linear_10_30035)" />
                            <path d="M307 184C285.568 181.334 249.847 189.359 222.181 132.154C187.598 60.6465 161.355 63.6813 103.989 67.6728C62.2956 70.5738 37.3181 43.0683 26 24" stroke="#5BF0A5" stroke-width="3.14635" />
                        </g>

                        <defs>
                            <linearGradient id="paint0_linear_10_30035" x1="335" y1="47.207" x2="0.438385" y2="47.207" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                                <stop offset="0.33" stop-color="#F2F4F6" />
                                <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                            </linearGradient>
                            <linearGradient id="paint1_linear_10_30035" x1="335" y1="83.9141" x2="0.438385" y2="83.9141" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                                <stop offset="0.33" stop-color="#F2F4F6" />
                                <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                            </linearGradient>
                            <linearGradient id="paint2_linear_10_30035" x1="335" y1="120.621" x2="0.438385" y2="120.621" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                                <stop offset="0.33" stop-color="#F2F4F6" />
                                <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                            </linearGradient>
                            <linearGradient id="paint3_linear_10_30035" x1="335" y1="157.33" x2="0.438385" y2="157.33" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                                <stop offset="0.33" stop-color="#F2F4F6" />
                                <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                            </linearGradient>
                            <linearGradient id="paint4_linear_10_30035" x1="335" y1="194.037" x2="0.438385" y2="194.037" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                                <stop offset="0.33" stop-color="#F2F4F6" />
                                <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                            </linearGradient>
                            <linearGradient id="paint5_linear_10_30035" x1="230.863" y1="29.7554" x2="156.186" y2="214.61" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#5BF0A5" />
                                <stop offset="1" stop-color="white" stop-opacity="0" />
                            </linearGradient>
                            <clipPath id="clip0_10_30035">
                                <rect width="1.04878" height="11.5366" fill="white" transform="matrix(-1 0 0 1 308.488 185.146)" />
                            </clipPath>
                            <clipPath id="clip1_10_30035">
                                <rect width="282" height="169" fill="white" transform="matrix(-1 0 0 1 307 24)" />
                            </clipPath>
                        </defs>
                    </svg>


                </div>
            </div>
            <svg style={{zIndex: '1'}} width="335" height="204" viewBox="0 0 335 204" fill="none" xmlns="http://www.w3.org/2000/svg">

                <g id='circle'>

                    <circle cx="6.2927" cy="6.2927" r="6.2927" transform="matrix(-1 0 0 1 315 173)" fill="#5BF0A5" />
                    <circle cx="6.2927" cy="6.2927" r="11.7927" transform="matrix(-1 0 0 1 315 173)" stroke="#5BF0A5" stroke-opacity="0.5" stroke-width="11" />
                    <circle cx="6.2927" cy="6.2927" r="15.2927" transform="matrix(-1 0 0 1 315 173)" stroke="#5BF0A5" stroke-opacity="0.2" stroke-width="18" />
                    <circle cx="6.2927" cy="6.2927" r="7.2927" transform="matrix(-1 0 0 1 315 173)" stroke="white" stroke-width="2" />
                </g>
                <circle cx="6.2927" cy="6.2927" r="7.34148" transform="matrix(-1 0 0 1 32.5859 20)" fill="#5BF0A5" stroke="white" stroke-width="2.09757" />

            </svg>
            <svg width="335" height="204" viewBox="0 0 335 204" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.6" d="M335 46.707H0.438387" stroke="url(#paint0_linear_10_30035)" stroke-width="1.04878" />
                <path opacity="0.7" d="M335 83.4141H0.438387" stroke="url(#paint1_linear_10_30035)" stroke-width="1.04878" />
                <path opacity="0.8" d="M335 120.121H0.438387" stroke="url(#paint2_linear_10_30035)" stroke-width="1.04878" />
                <path opacity="0.9" d="M335 156.83H0.438387" stroke="url(#paint3_linear_10_30035)" stroke-width="1.04878" />
                <path d="M335 193.537H0.438387" stroke="url(#paint4_linear_10_30035)" stroke-width="1.04878" />
                <g clip-path="url(#clip0_10_30035)">
                    <rect width="1.04878" height="8.39026" rx="0.524391" transform="matrix(-1 0 0 1 308.488 185.146)" fill="#CAD4DD" />
                </g>
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 30.9746)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 41.4629)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 51.9502)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 62.4385)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 72.9258)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 83.4141)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 93.9014)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 104.39)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 114.877)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 125.365)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 135.853)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 146.341)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 156.828)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 167.316)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 177.804)" fill="#CAD4DD" />
                <rect width="1.04878" height="5.24391" rx="0.524391" transform="matrix(-1 0 0 1 26.4375 188.292)" fill="#CAD4DD" />
                <g clip-path="url(#clip1_10_30035)">
                    <path d="M307 184C285.568 181.334 249.847 189.359 222.181 132.154C187.598 60.6465 161.355 63.6813 103.989 67.6728C62.2956 70.5738 37.3181 43.0683 26 24" stroke="#F2F4F6" stroke-width="3.14635" />

                </g>

                <defs>
                    <linearGradient id="paint0_linear_10_30035" x1="335" y1="47.207" x2="0.438385" y2="47.207" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                        <stop offset="0.33" stop-color="#F2F4F6" />
                        <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_10_30035" x1="335" y1="83.9141" x2="0.438385" y2="83.9141" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                        <stop offset="0.33" stop-color="#F2F4F6" />
                        <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_10_30035" x1="335" y1="120.621" x2="0.438385" y2="120.621" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                        <stop offset="0.33" stop-color="#F2F4F6" />
                        <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_10_30035" x1="335" y1="157.33" x2="0.438385" y2="157.33" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                        <stop offset="0.33" stop-color="#F2F4F6" />
                        <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_10_30035" x1="335" y1="194.037" x2="0.438385" y2="194.037" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F2F4F6" stop-opacity="0.2" />
                        <stop offset="0.33" stop-color="#F2F4F6" />
                        <stop offset="1" stop-color="#F2F4F6" stop-opacity="0.2" />
                    </linearGradient>
                    <linearGradient id="paint5_linear_10_30035" x1="230.863" y1="29.7554" x2="156.186" y2="214.61" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#5BF0A5" />
                        <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                    <clipPath id="clip0_10_30035">
                        <rect width="1.04878" height="11.5366" fill="white" transform="matrix(-1 0 0 1 308.488 185.146)" />
                    </clipPath>
                    <clipPath id="clip1_10_30035">
                        <rect width="282" height="169" fill="white" transform="matrix(-1 0 0 1 307 24)" />
                    </clipPath>
                </defs>
            </svg>



            {/* <img src={process.env.PUBLIC_URL + `/img/Graph-line.svg`} alt="" /> */}
        </div>
    )
}
